// extracted by mini-css-extract-plugin
module.exports = {"container":"service_container__2mliq","container__modal":"service_container__modal__1K2EW","list__check":"service_list__check__prCWO","list__span":"service_list__span__pDM_6"};